/* eslint-disable @typescript-eslint/default-param-last */
import {
  CREATE_CAMPAIGN,
  GET_CAMPAIGN_DETAILS,
  UPDATE_CAMPAIGN,
} from '../../constants/ActionTypes';
import { ActionType } from '../../types/Interviews/interviews.types';
import {
  ICampaignData,
  ICampaignState,
} from '../../types/dhwani/campaign.types';

const initialState: ICampaignState = {
  campaignData: null,
  loading: false,
  error: null,
};

interface CampaignAction {
  type: string;
  payload: any;
}

/**
 * Campaign Reducer
 * @param {ICampaignState} state
 * @param {CampaignAction} action
 * @returns {ICampaignState}
 */
const campaignReducer = (
  state: ICampaignState = initialState,
  action: CampaignAction | ActionType
): ICampaignState => {
  switch (action?.type) {
    case `${GET_CAMPAIGN_DETAILS}_LOADING`:
      return {
        ...state,
        loading: true,
      };
    case `${GET_CAMPAIGN_DETAILS}_LOADED`:
      return {
        ...state,
        loading: false,
      };
    case `${GET_CAMPAIGN_DETAILS}_RESET`:
      return {
        ...state,
        campaignData: null,
        loading: false,
        error: null,
      };
    case `${GET_CAMPAIGN_DETAILS}_SUCCESS`:
      return {
        ...state,
        campaignData: action.payload,
        loading: false,
      };
    case `${CREATE_CAMPAIGN}_SUCCESS`:
    case `${UPDATE_CAMPAIGN}_SUCCESS`:
      return {
        ...state,
        campaignData: action.payload,
        loading: false,
      };
    case `${CREATE_CAMPAIGN}_FAILURE`:
    case `${UPDATE_CAMPAIGN}_FAILURE`:
    case `${GET_CAMPAIGN_DETAILS}_FAILURE`:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default campaignReducer;
